import { gql, useQuery } from '@apollo/client';

const GET_TEMPLATE_TYPES = gql`
  query getConsolidatedAssetCashflowsTemplateTypes {
    consolidatedAssetCashflowsTemplateTypes {
      id
      name
    }
  }
`;

export const useCashflowTemplateTypes = () => {
  const { data, loading, error } = useQuery(GET_TEMPLATE_TYPES);

  return {
    templateTypes: data?.consolidatedAssetCashflowsTemplateTypes ?? [],
    loading,
    error,
  };
};
